// extracted by mini-css-extract-plugin
module.exports = {"breakpoint-tablet":"(min-width: 520px)","flexContainer":"CityBlocks-module--flexContainer--ad9edc"};